package tech.gensert.portal.web.pages

import react.FC
import react.Props
import react.router.useNavigate
import react.useEffect
import tech.gensert.portal.web.config.cookies.clearCookies
import tech.gensert.portal.web.wrappers.useMsal

val LogoutPage = FC<Props> {
    val context = useMsal()
    val instance = context.instance
    val navigate = useNavigate()
    useEffect(dependencies = emptyArray()) {
        instance.logoutRedirect()
            .then {
                clearCookies()
            }
            .catch { e ->
                clearCookies()
            }
    }
}


